import type { ObjectId } from '@freightview/object-id'

import {
  vCountryAny,
  vCurrency,
  vEmailOrEmpty,
  vMinLength,
  vNonEmptyString,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPhoneExt,
  vPhoneNumber,
  vPicklist,
  vPipe,
  vPostalCode,
  vString,
} from '../validation/index.ts'
import type { AddressBase } from './address.ts'
import type { Currency } from './common.ts'
import type { Country } from './country.ts'

export const customsBrokerTypes = ['import', 'export'] as const
export type CustomsBrokerType = (typeof customsBrokerTypes)[number]

export const baseCustomsBrokerSchema = vObject({
  address: vOptional(vString()),
  address2: vOptional(vString()),
  city: vOptional(vString()),
  companyName: vNonEmptyString(),
  country: vOptional(vCountryAny),
  email: vOptional(vEmailOrEmpty),
  phone: vPipe(vPhoneNumber(), vMinLength(1)),
  phoneExt: vOptional(vPhoneExt()),
  postalCode: vOptional(vPostalCode()),
  state: vOptional(vString()),
  type: vOptional(vPicklist(customsBrokerTypes)),
  value: vOptional(vNumber()),
  valueCurrency: vOptional(vCurrency('usd')),
})
export type ShipmentCustomsBrokerDto = vOutput<typeof baseCustomsBrokerSchema>

type CustomsBrokerBase = Omit<
  AddressBase,
  'address' | 'city' | 'state' | 'postalCode' | 'country'
> & {
  address?: string
  city?: string
  state?: string
  postalCode?: string
  country?: Country
  companyName: string
  email?: string
  phone: string
  phoneExt?: string
  value?: number
  valueCurrency?: Currency
  type?: CustomsBrokerType
}

export type AccountCustomsBroker = CustomsBrokerBase & {
  _id: ObjectId
  created: Date
  accountId: ObjectId
}
export type LoadCustomsBroker = CustomsBrokerBase & {
  addressBookId?: string
}
